import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesService {

  private url = environment.api;
  constructor(
    private http: HttpClient,
  ) { }

  getSalesByIntervalDate(startDate: number, endDate: number) {
    return this.http.get(this.url + 'api/erp/sale/invoices/search', {
      params: {
        startDate: startDate,
        endDate: endDate
      }
    })
  }

  getClientInvoicesToAnulInFiscal() {
    return this.http.get(this.url + 'api/erp/sale/invoices/search-for-annul');
  }

  downloadPdf(invoice: any) {
    return this.http.get(this.url + "api/erp/sale/invoices/pdf/" + invoice.id, { responseType: 'arraybuffer' });
  }

  performConversion(invoice: any) {
    return this.http.post(this.url + 'api/invoicingv2/transform/voucher?clientInvoiceId=' + invoice.id + '&warehouseId=' + invoice.warehouse, invoice);
  }

  deleteInvoice(invoice: any) {
    return this.http.delete(this.url + "api/erp/sale/invoices/" + invoice.id);
  }

  cancelInvoice(invoice: any, cancelledDescription: string) {
    return this.http.post(this.url + "api/erp/sale/invoices/cancel/" + invoice.id + '/' + cancelledDescription, {});
  }

  getDetailInvoice(invoice: any) {
    return this.http.get(this.url + "api/erp/sale/invoices/detail/" + invoice.id);
  }

  getTaxRegimeCompany() {
    return this.http.get(this.url + "api/erp/sale/invoices/company-tax-regime");
  }

  getDetailInvoiceCot(invoice: any) {
    return this.http.get(this.url + "api/erp/sale/invoices/detailCot/" + invoice.id);
  }

  getDetailBackendInvoice(backendInvoice: any) {
    return this.http.get(this.url + "api/erp/sale/invoices/detailBackend/" + backendInvoice.id);
  }

  getDetailSeries(series: string, number: string) {
    return this.http.get(this.url + `api/erp/sale/invoices/detailSeries/${series}/${number}`);
  }

  putInvoice(invoiceId: number, newData: any) {
    return this.http.put(this.url + "api/erp/sale/invoices/" + invoiceId, newData);
  }

  transformProductSale(companyId: number, invoiceId: number, idProductSon: number, idProductFath: number) {
    return this.http.post(this.url + `api/erp/sale/invoices/adjustment/${invoiceId}/${idProductSon}/${idProductFath}`, {}, {
      headers: {
        'ININ-Company': companyId.toString()
      }
    });
  }

  getMethodPaymentByInvoice(invoiceId: number): any {
    return this.http.get(this.url + 'api/erp/sale/invoices/method-payment/'+invoiceId)
  }
}
